const PROJECT_DICTIONARY = [
  'Mae',
  'Fah',
  'Luang',
  'MFU',
  'MOU',
  'MOUs',
  'DDP',
  'Naradisorn',
  'Matchima',
  'Sutthiwal',
  'Setha'
]

const importedDictionaryWords = new Set()
let harperRuntimePromise = null

function normalizeDictionaryWord(word) {
  const value = String(word || '').trim().replace(/^[^A-Za-z]+|[^A-Za-z]+$/g, '')
  return value.length >= 2 ? value : ''
}

function collectContextWords(values) {
  const words = new Set(PROJECT_DICTIONARY)

  ;(Array.isArray(values) ? values : []).forEach((value) => {
    const matches = String(value || '').match(/[A-Za-z][A-Za-z'-]*/g)
    if (!matches) return

    matches.forEach((match) => {
      const cleaned = normalizeDictionaryWord(match)
      if (cleaned) words.add(cleaned)
    })
  })

  return Array.from(words)
}

function buildTunedConfig(defaultConfig) {
  const nextConfig = Object.assign({}, defaultConfig || {})

  if (Object.prototype.hasOwnProperty.call(nextConfig, 'LongSentences')) {
    nextConfig.LongSentences = false
  }

  if (Object.prototype.hasOwnProperty.call(nextConfig, 'SpelledNumbers')) {
    nextConfig.SpelledNumbers = false
  }

  if (Object.prototype.hasOwnProperty.call(nextConfig, 'WrongQuotes')) {
    nextConfig.WrongQuotes = false
  }

  return nextConfig
}

async function ensureDictionaryWords(runtime, words) {
  const pendingWords = collectContextWords(words).filter((word) => {
    const normalized = word.toLowerCase()
    return normalized && !importedDictionaryWords.has(normalized)
  })

  if (!pendingWords.length) return

  await runtime.linter.importWords(pendingWords)
  pendingWords.forEach((word) => importedDictionaryWords.add(word.toLowerCase()))
}

async function createHarperRuntime() {
  const [{ WorkerLinter, Dialect }, { binaryInlined }] = await Promise.all([
    import('harper.js/dist/index.js'),
    import('harper.js/dist/binaryInlined.js')
  ])

  const linter = new WorkerLinter({
    binary: binaryInlined,
    dialect: Dialect.British
  })

  await linter.setup()
  await linter.setLintConfig(buildTunedConfig(await linter.getDefaultLintConfig()))
  await ensureDictionaryWords({ linter }, PROJECT_DICTIONARY)

  return { linter }
}

async function getHarperRuntime() {
  if (!harperRuntimePromise) {
    harperRuntimePromise = createHarperRuntime().catch((error) => {
      harperRuntimePromise = null
      throw error
    })
  }

  return harperRuntimePromise
}

export async function warmupHarperGrammar() {
  await getHarperRuntime()
}

export async function lintHarperGrammar(text, options = {}) {
  const runtime = await getHarperRuntime()
  await ensureDictionaryWords(runtime, options.contextValues)

  return runtime.linter.lint(String(text || ''), {
    language: 'markdown'
  })
}

export async function applyHarperGrammarSuggestion(text, lint, suggestion) {
  const runtime = await getHarperRuntime()
  return runtime.linter.applySuggestion(String(text || ''), lint, suggestion)
}
